"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Micro = _interopRequireDefault(require("../Micro/Micro"));

var _utils = require("./utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function AlloMicro(_ref) {
  var brand = _ref.brand,
      user = _ref.user,
      integration = _ref.integration,
      custom = _ref.custom,
      handleEnd = _ref.handleEnd,
      language = _ref.language,
      color = _ref.color,
      env = _ref.env,
      maxTime = _ref.maxTime,
      modelEndpointId = _ref.modelEndpointId;
  var micData = {};

  var _useState = (0, _react.useState)('pre'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      recordingState = _useState2[0],
      setRecordingState = _useState2[1];

  localStorage.stage = env || ""; //console.log(localStorage, localStorage.stage)

  var audioData = {};
  (0, _react.useEffect)(function () {
    if (recordingState == 'post') {
      var file_id = (0, _utils.sendAudio)(audioData, brand, user, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, integration), custom));

      if (handleEnd) {
        handleEnd((0, _objectSpread2.default)((0, _objectSpread2.default)({}, micData), {}, {
          'file_id': file_id
        }));
      }
    }
  }, [recordingState]);

  var handleMicrophone = function handleMicrophone(state, data, audioBlob) {
    micData = data;
    setRecordingState(state);

    if (state == 'post') {
      audioData['audioBlob'] = audioBlob;
      audioData['audioData'] = data;
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_Micro.default, {
    parentHandler: handleMicrophone,
    language: language,
    color: color,
    maxTime: maxTime,
    brand: brand,
    modelEndpointId: modelEndpointId
  }));
}

var _default = AlloMicro;
exports.default = _default;